import {
  dateFormatterDayMonth,
  HomeChargingSupportingDocumentStatus,
  Spacer,
  TableTagHomeChargingSupportingDocumentStatus,
  TextCapitalized,
} from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { formatDateWithoutDay } from "../../../../../libSlice/materialUiFormats";
import {
  GetHomeChargingSupportingDocumentsPayload,
  HomeChargingSupportingDocument,
} from "../../homeChargingSupportingDocumentsAPI";
import "../../../../../i18n/i18n";

export const SidePanelHeader = (props: {
  supportingDocument: HomeChargingSupportingDocument;
  status: HomeChargingSupportingDocumentStatus;
  period: GetHomeChargingSupportingDocumentsPayload;
}) => {
  const { t } = useTranslation();
  const { supportingDocument, status, period } = props;

  return (
    <StyledPanelContainer>
      <StyledTitle>
        <TextCapitalized>
          {t("home_charging_supporting_documents.sidePanel.title")}
        </TextCapitalized>
      </StyledTitle>
      <Spacer y={1} />
      <TableTagHomeChargingSupportingDocumentStatus
        status={status}
        createdAt={supportingDocument.supportingDocument?.createdAt ?? null}
        createdBy={supportingDocument.supportingDocument?.createdBy ?? null}
      />
      <Spacer y={1.5} />
      <StyledRowAmount>
        <StyledAmount>
          {supportingDocument.reimbursementAmount.toFixed(2)}
        </StyledAmount>
        <StyledCurrency>&nbsp;EUR</StyledCurrency>
      </StyledRowAmount>
      <Spacer y={1} />
      <StyledBodyM>{formatDateWithoutDay(period.from)}</StyledBodyM>
      <Spacer y={0.25} />
      <StyledDate>
        <TextCapitalized>
          {t("home_charging_supporting_documents.sidePanel.period", {
            lastDay: dateFormatterDayMonth(new Date(period.to)),
          })}
        </TextCapitalized>
        <div>
          {t("home_charging_supporting_documents.sidePanel.chargesSummary", {
            count: supportingDocument.chargesCount,
            totalEnergy: supportingDocument.totalEnergy,
          })}
        </div>
      </StyledDate>
    </StyledPanelContainer>
  );
};

const StyledPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledTitle = styled.div`
  ${typographies["Header/H3"]};
  color: ${colors["colors/text/black"]};
`;

const StyledRowAmount = styled.div`
  display: flex;
  align-items: flex-end;
`;

const StyledAmount = styled.div`
  ${typographies["Title/H1"]};
`;

const StyledCurrency = styled.div`
  ${typographies["Paragraph/P1"]};
`;

const StyledBodyM = styled.div`
  ${typographies["Body/M"]};
`;

const StyledDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${typographies["Body/XXS"]};
  color: ${colors["colors/text/darkGrey"]};
`;
